<script setup lang="ts">
const { t } = useI18n()
const container = useTemplateRef('container')
const animationRotating = useTemplateRef('animationRotating')
const isVisible = useElementVisibility(container)

const currentSlotIndex = ref(0)
const totalColumnsToDisplay = ref(2)

const columns: SchemaTableColumn[] = [
  {
    icon: getIcon('email'),
    key: 'name',
    size: 2,
    title: t('columns.email'),
  },
  {
    icon: getIcon('industries'),
    key: 'industries',
    title: t('columns.industries'),
  },
  {
    badgeColor: 'violet',
    icon: getIcon('totalEmployees'),
    key: 'totalEmployees',
    title: t('columns.totalEmployees'),
  },

]

const rows: SchemaTableRow[] = [
  {
    image: getLogo('thecompaniesapi.com', 'companies')!,
    industries: ['B2B', 'Data'],
    name: 'julien@thecompaniesapi.com',
    totalEmployees: '1-10',
  },
  {
    image: getLogo('crisp.chat', 'companies')!,
    industries: ['Livechat', 'Helpdesk'],
    name: 'baptiste@crisp.chat',
    totalEmployees: '10-50',
  },
  {
    image: getLogo('livestorm.co', 'companies')!,
    industries: ['Webinar', 'Leads'],
    name: 'gilles@livestorm.co',
    totalEmployees: '50-200',
  },
  {
    image: getLogo('scribe-mail.com', 'companies')!,
    industries: ['Signature', 'Marketing'],
    name: 'clement@scribe-mail.com',
    totalEmployees: '1-10',
  },
  {
    image: getLogo('linkedin.com', 'companies')!,
    industries: ['Social', 'Business'],
    name: 'gwladys.lee@linkedin.com',
    totalEmployees: 'over-10k',
  },
  {
    image: getLogo('anyleads.com', 'companies')!,
    industries: ['Email', 'Leads'],
    name: 'mathieu@anyleads.com',
    totalEmployees: '1-10',
  },
  {
    image: getLogo('waystar-royco.com', 'companies')!,
    industries: ['News', 'Entertainment'],
    name: 'tom@waystar-royco.com',
    totalEmployees: '1k-5k',
  },
  {
    image: getLogo('bearanalytics.com', 'companies')!,
    industries: ['Analytics', 'Marketing'],
    name: 'joe@bearanalytics.com',
    totalEmployees: '10-50',
  },
]

const slots = [
  'industries',
  'industries-loading',
  'totalEmployees',
  'totalEmployees-loading',
  'completed',
]

const columnsToDisplay = computed(() => {
  return columns.slice(0, totalColumnsToDisplay.value)
})

watch(currentSlotIndex, (value) => {
  if (value % 2 === 1) {
    totalColumnsToDisplay.value = Math.min(totalColumnsToDisplay.value + 1, 3)
  }
})

watch(isVisible, (value) => {
  if (value) {
    currentSlotIndex.value = 0
    totalColumnsToDisplay.value = 2
    animationRotating.value?.reset()
  }
})
</script>

<template>
  <div
    ref="container"
    class="flex size-full flex-col"
  >
    <Transition
      enter-active-class="transition-base delay-50 transform-gpu"
      enter-from-class="opacity-0 translate-y-24"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition-base"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-24"
    >
      <SchemaTable
        v-if="isVisible"
        :columns="columnsToDisplay"
        :loadable-columns="['industries', 'totalEmployees']"
        :loading-text="t('globals.enriching')"
        :rows="rows"
      />
    </Transition>

    <AnimationRotating
      ref="animationRotating"
      v-model="currentSlotIndex"
      direction="vertical"
      once
      :slots="slots"
    />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "columns": {
      "email": "Email",
      "industries": "Industries",
      "totalEmployees": "Employees"
    }
  },
  "es": {
    "columns": {
      "email": "Correo electrónico",
      "industries": "Industrias",
      "totalEmployees": "Empleados"
    }
  },
  "fr": {
    "columns": {
      "email": "E-mail",
      "industries": "Industries",
      "totalEmployees": "Employés"
    }
  }
}
</i18n>
